
<app-dashboard-sidebar></app-dashboard-sidebar>
<div class="pull-right mx-2 m-1">
  <button class="primary-btn mx-3" (click)="updateDash()">Save
    <i class="fa fa-save ml-5"></i>
  </button>
</div>
<gridster [options]="options" class="dashboard-item-container mt-2" (drop)="onDrop($event)" style="background-color:#eff3f8;">

  @for (item of dashboardArray; track item; let i = $index) {
    <gridster-item [item]="item" class="border dashboard-item {{item.selector}}">
      <div class="position-absolute d-inline-flex" style="z-index:1">
        <div class="btn-group border rounded border-dark bg-white">
          <button class="btn btn-icon btn-sm" (click)="removeItem(i)">
            <i class="fa fa-trash"></i>
          </button>
          <span class="border border-secondary"></span>
          <button class="btn btn-icon btn-sm drag-handler">
            <i class="fa fa-arrows-alt"></i>
          </button>
          <span class="border border-secondary"></span>
          @if (this.widgetCollection && this.widgetCollection.length>0 && config[item.selector] != undefined) {
            <select name="widgetType" class="btn btn-sm bg-white"
              [ngModel]="item.widget_id?item.widget_id:''" (change)="setWidget(item,$event,i)">
              <option value="">Select</option>
              @for (widget of config[item.selector]; track widget) {
                <option [value]="widget.id">{{widget.widget_name}}
                </option>
              }
            </select>
          }
          @if (this.widgetCollection && this.widgetCollection.length>0 && config[item.widg_selector] != undefined) {
            <select name="widgetType" class="btn btn-sm bg-white"
              [ngModel]="item.widget_id?item.widget_id:''" (change)="setWidget(item,$event,i)">
              <option value="">Select</option>
              @for (widget of config[item.widg_selector]; track widget) {
                <option [value]="widget.id">{{widget.widget_name}}
                </option>
              }
            </select>
          }
        </div>
      </div>
      <!-- <div class="row h-100" *ngIf="(item.selector==undefined|| item.selector=='')&&item.imageUrl!=undefined">
      <img src="./assets/images/{{item.imageUrl}}" class="m-auto h-25 w-25">
    </div> -->
    <div class="h-100">
      <ng-template #customComponent></ng-template>
    </div>
  </gridster-item>
}
</gridster>
